<template>
    <InputContainer :label="label" :name="name" :errors="errors" :showErrors="showErrors">
        <div class="base-input-container">
            <textarea
                v-bind="$attrs"
                :id="name"
                :value="modelValue"
                :rows="rows"
                class="base-textarea"
                data-test="base-textarea"
                :data-cy="$attrs.id"
                spellcheck="false"
                @input="handleInput"
                :class="{ hasError: showErrors }"
            />
        </div>
    </InputContainer>
</template>

<script>
import InputContainer from "@/components/inputs/InputContainer";
import inputs from "@/mixins/inputs.js";

export default {
    name: "LaBaseTextarea",
    components: {
        InputContainer,
    },
    mixins: [inputs],
    props: {
        modelValue: {
            required: false,
            default: "",
            type: String,
        },
        rows: {
            type: Number,
            default: 3,
        },
    },
};
</script>

<style lang="scss" scoped>
.base-textarea {
    width: 100%;
    min-width: 20rem;
    background-color: $light-blue;
    border: 1px solid darken($light-blue, 15%);
    border-radius: $normal-radius;
    padding: 0.7rem;
    color: $blue;
    font-family: monospace;
    font-size: 0.85rem;
    resize: vertical;
    @include --big-mobile-viewport {
        min-width: inherit;
    }
    &.hasError {
        border-color: $red;
    }
}
</style>
